<template>
  <div v-if="comments.slice(0, sliceComments).length" class="d-grid grid-cols-1 gap-10px mt-20px">
    <template v-for="comment in comments.slice(0, sliceComments)">
      <Comment :comment="comment" @delete-comment="$emit('deleteComment', comment.id)" />
    </template>
  </div>

  <div class="collapse" :id="toggleClass">
    <div class="d-grid grid-cols-1 gap-15px mt-20px">
      <template v-for="comment in comments.slice(sliceComments)">
        <Comment :comment="comment" @delete-comment="$emit('deleteComment', comment.id)" />
      </template>
    </div>
  </div>

  <p class="mt-10px mb-0" v-if="comments.length > sliceComments">
    <a href="#" class="fs-sm" role="button" data-bs-toggle="collapse" :data-bs-target="'#' + toggleClass" @click="toggledComments = !toggledComments">
      <span v-if="!toggledComments">Zobraziť viac</span>
      <span v-if="toggledComments">Zobraziť menej</span>
    </a>
  </p>
</template>

<script>
import Comment from "./Comment.vue";

export default {
  name: "CommentWrapper",
  emits: ['deleteComment'],
  components: { Comment },
  props: {
    comments: Array,
    toggleClass: {
      type: String,
      default: 'commentsToggle'
    },
    sliceComments: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      toggledComments: false,
    }
  },
}
</script>

<style scoped>

</style>
